import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { App } from './App';
import { I18nProvider, useI18n } from './i18n';
import { useVisualViewport } from './useVisualViewport';
import type { SuzanohConfig } from './types';

function NotFoundFatal() {
  const { t } = useI18n();
  return (
    <div className="fullscreen-error" role="alert">
      <h1>{t('state.notFound')}</h1>
      <p>{t('state.notFound.description')}</p>
    </div>
  );
}

function Root({ config }: { config: SuzanohConfig }) {
  useVisualViewport();
  return (
    <I18nProvider locale={config.locale}>
      <App config={config} />
    </I18nProvider>
  );
}

function mount() {
  const container = document.getElementById('suzanoh-chat-root');
  if (!container) {
    // eslint-disable-next-line no-console
    console.error('[suzanoh-chat] #suzanoh-chat-root not found');
    return;
  }
  const config = window.__SUZANOH_CONFIG__;
  const root = createRoot(container);
  if (!config) {
    // config 無いケースの NotFoundFatal も I18nProvider 配下にする (locale は navigator から検出)
    root.render(
      <StrictMode>
        <I18nProvider>
          <NotFoundFatal />
        </I18nProvider>
      </StrictMode>,
    );
    return;
  }
  root.render(
    <StrictMode>
      <Root config={config} />
    </StrictMode>,
  );
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount);
} else {
  mount();
}
